import { DocumentMap, IDocumentsList } from '../../../../types';
import ChecklistSection from '../../../atoms/checklist-section';
import Finger, { Status } from '../../../atoms/finger';
import { getVisible, getDocStatus } from '../../../../utilities/documents';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import { useIsSectionLocked } from '../../../../hooks/useIsSectionLocked';
import { SectionId } from '../../../molecules/Sidebar/types';

interface IProps {
  documents: DocumentMap;
  onResume: (url: string) => void;
  onClick: (docKey: string, infoOnly: boolean) => void;
  englishTestQualification?: string;
  qualificationOther?: string;
  infoOnly: boolean;
}

const EnglishQualification = (props: IProps) => {
  const { documents, englishTestQualification, infoOnly, qualificationOther } = props;
  const offer = useSelector((state: ApplicationState) => state.student.offer);
  const isSectionLocked = useIsSectionLocked(SectionId.GENERAL_DOC, offer.status);

  const visibleDocs = getVisible(documents, infoOnly) as IDocumentsList[];
  if (visibleDocs.length === 0) return null;

  const qualificationName = englishTestQualification || qualificationOther;
  // You must upload a scan of the certificate or transcript that you used to meet the English language requirement.
  const label = qualificationName
    ? `Upload your ${qualificationName} qualification used to meet the English language requirement`
    : '';
  return (
    <ChecklistSection
      id={'english-qualification-doc'}
      label={label}
      edit={() => {
        props.onResume('history/step-4');
      }}
    >
      {visibleDocs.map((qualificationDOc: IDocumentsList, index: number) => {
        const { key: docKey, item } = qualificationDOc;
        if (item.status === 'REJECTED') {
          return (
            <Finger
              hideButton={true}
              reason={item.reason}
              key={`english-qualification-${index}`}
              id={`english-qualification-${index}`}
              status={Status.Rejected}
              label={`${qualificationName} certificate or transcript`}
            />
          );
        } else {
          return (
            <Finger
              key={`english-qualification-${index}`}
              id={`english-qualification-${index}`}
              status={getDocStatus(item.status, infoOnly, isSectionLocked)}
              completeLabel={infoOnly ? 'View' : undefined}
              resolveLabel={infoOnly ? 'Please Confirm' : undefined}
              buttonLabel={infoOnly ? 'Please review' : undefined}
              label={`${qualificationName} certificate or transcript`}
              onClick={() => props.onClick(docKey, infoOnly)}
            />
          );
        }
      })}
    </ChecklistSection>
  );
};

export default EnglishQualification;
